import { z } from 'zod';
/**
 * Financing commission (Einstellungen 29, Finanzierungen 06/08/10), the financier matching (Deal-Akte 06) and the
 * controlling figures (Controlling 04) — docs/dev/api-financing-commission.md, docs/dev/api-controlling.md. Request
 * schemas are shared by the API (validation) and the SPA (forms); the response types describe what the API sends.
 */
/** A percentage with at most three decimals between 0 and 100 (`numeric(6,3)`). */
export const commissionPctSchema = z
    .number()
    .min(0)
    .max(100)
    .refine((value) => Math.abs(Math.round(value * 1000) - value * 1000) < 1e-6, {
    message: 'Höchstens drei Nachkommastellen.',
});
// --- Einstellungen 29 ---------------------------------------------------------------------------------------
export const financingCommissionSettingsBodySchema = z.object({
    financiers: z.array(z.object({ userId: z.uuid(), ratePct: commissionPctSchema })).max(500),
    shares: z.array(z.object({ userId: z.uuid(), sharePct: commissionPctSchema })).max(500),
});
// --- the commission card and the live distribution ----------------------------------------------------------
export const financingCommissionShareViewSchema = z.object({
    userId: z.string(),
    name: z.string(),
    roleLabel: z.string(),
    sharePct: z.number(),
    amountCents: z.number(),
});
/**
 * Sidebar „Provision" of the financing record (Finanzierungen 06/08). The totals are null for a viewer who only
 * sees own shares and is not the deal's closer (`deals.view_commission = own`, §4.3).
 */
export const financingCommissionCardSchema = z.object({
    status: z.enum(['preview', 'due', 'cancelled']),
    dueLabel: z.string(),
    amountCents: z.number().nullable(),
    ratePct: z.number().nullable(),
    baseCents: z.number().nullable(),
    baseLabel: z.string().nullable(),
    shares: z.array(financingCommissionShareViewSchema),
    organizationCents: z.number().nullable(),
    note: z.string(),
});
export const commissionPreviewQuerySchema = z.object({
    dealId: z.uuid(),
    ratePct: z.coerce.number().pipe(commissionPctSchema),
    amountCents: z.coerce.number().int().min(0).max(100_000_000_000),
});
// --- matching (Deal-Akte 06, D4) ------------------------------------------------------------------------------
export const financierCandidateSchema = z.object({
    userId: z.string(),
    name: z.string(),
    initials: z.string(),
    line: z.string(),
    openCases: z.number(),
    matches: z.number(),
    best: z.boolean(),
});
// --- Controlling 04 -------------------------------------------------------------------------------------------
export const figuresPeriods = ['week', 'month', 'quarter'];
export const figuresQuerySchema = z.object({
    period: z.enum(figuresPeriods).default('month'),
    scope: z.enum(['me', 'team', 'organization']).optional(),
});
export const funnelKeys = [
    'leads',
    'reached',
    'booked',
    'attended',
    'deals',
    'reserved',
    'notarized',
];
/** Sub-row of the partner's contacts without a referrer version of the partner (matched contacts). */
export const REFERRER_NO_SUBMITTER_LABEL = 'Ohne Einreicher';
/** Empty state of the „Tippgeber-Partner" table. */
export const REFERRER_FIGURES_EMPTY_TEXT = 'Keine Tippgeber-Einreichungen im Zeitraum.';
/** Suffix of an inactive partner's name in the table and the CSV export. */
export const REFERRER_INACTIVE_SUFFIX = ' (inaktiv)';
//# sourceMappingURL=financing-commission.js.map